module.exports = __webpack_public_path__ + "static/product_plan-b3e7a08e301f066f168db3db984d5eaf.png";